import React from 'react'
import ChartistGraph from 'react-chartist'
import ChartistAccessibility from 'react-chartist-plugin-accessibility'

class Bar extends React.Component {
	render() {
		const {
			caption,
			data,
			header,
			options,
			summary
		} = this.props
		return (
			<ChartistGraph
				data={data}
				options={options}
				type={'Bar'}>
				<ChartistAccessibility
					caption={caption}
					summary={summary}
					seriesHeader={header}
				/>
			</ChartistGraph>
		)
	}
}

export default Bar